import { baseUrlApi } from "./Api.js"

export default {
  imagesPath(path) {
    return `${baseUrlApi}/${path}`;
  }
};

